export default "/static/build/rewards-new.png";